module.exports = __webpack_public_path__ + "media/images/emblems/Froideville-coat_of_arms-948a851d19f60c7bcf0d0f0da5fcbe64.svg";